import { render, staticRenderFns } from "./MinhaContaPrivacidade.vue?vue&type=template&id=76ee1a85&scoped=true"
import script from "./MinhaContaPrivacidade.vue?vue&type=script&lang=js"
export * from "./MinhaContaPrivacidade.vue?vue&type=script&lang=js"
import style0 from "./MinhaContaPrivacidade.vue?vue&type=style&index=0&id=76ee1a85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ee1a85",
  null
  
)

export default component.exports